module.exports = __webpack_public_path__ + "static/seville-history-2-a535573a40fcdad012d71565f42789bf.jpg";